import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.split.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import USE_MERCURE from '~/const/mercure';
import logout from '~/helpers/logout-helper';
import * as types from './types';
import { createCart, fetchCart, addCart, updateCart, addCartCustomizable } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
import isValidToken from '~/helpers/connection-helper';

var formatCustomerCartQuantity = data => {
  var qty = data.split('|').find(a => a.includes('item_qty'));
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};

var getGraphQLErrorsCode = err => {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }

  return '';
};

var initCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (context) {
    sessionStorage.removeItem('MDM_CART_ADDRESSES');
    sessionStorage.removeItem('MDM_CART_PHONE');
    sessionStorage.removeItem('MDM_RESTORE_CART');
    sessionStorage.removeItem('MDM_CC_ELIGIBLE');
    var {
      createNewCart
    } = yield createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));

    if (!createNewCart) {
      throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');
    }

    localStorage.setItem('MDM_CART_TOKEN', createNewCart);
  });

  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  createCart() {
    var _this = this;

    return _asyncToGenerator(function* () {
      yield initCart(_this);
    })();
  },

  fetchCart(_ref2) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref2;
      var cart = null;
      var quantity = null;

      try {
        if (USE_MERCURE(_this2.getters['i18n/locale'].iso)) {
          if (!localStorage.getItem('MDM_CART_TOKEN')) return;
          var {
            data: {
              minicart
            },
            errors
          } = yield fetchCart(_this2, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'));

          if (errors) {
            var code = getGraphQLErrorsCode(errors);

            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }

            throw new Error(errors);
          }

          cart = minicart.items;
          quantity = minicart.quantity;
          commit(types.SET_CART_STATE, 'SUCCESS');
        } else {
          localStorage.removeItem('MDM_CART_TOKEN');
          var data = yield fetchCustomerCart(_this2);
          quantity = data.cart;

          if (data && data.user) {
            localStorage.setItem('MDM_MAIL', data.user.user_email);
          }
        }
      } catch (error) {
        _this2.$logger.error(error);

        commit(types.SET_CART_STATE, 'ERROR');
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
      }
    })();
  },

  add(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var {
        commit,
        state
      } = _ref3;
      var cart = null;
      var quantity = null;

      try {
        var item = state.items ? state.items.find(p => p.productReference === payload.reference) : {};
        var maxQuantityReached = item && item.quantity >= 30;

        if (USE_MERCURE(_this3.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            logout();
          }

          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this3);
          }

          if (!maxQuantityReached) {
            var {
              data: {
                addProductsToCart
              },
              errors
            } = yield addCart(_this3, _objectSpread({
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            }, payload));

            if (errors) {
              throw new Error({
                message: errors[0].message,
                errorType: 'gql'
              });
            }

            cart = addProductsToCart.items;
            quantity = addProductsToCart.quantity;
          } else {
            var totalQuantity = state.items.reduce((acc, pdt) => acc + pdt.quantity, 0);
            cart = state.items;
            quantity = totalQuantity;
          }
        } else {
          var data = yield addCustomerCart(_this3, payload);
          var currentTotal = state.total;
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: formatCustomerCartQuantity(data)
          }];
          quantity = currentTotal + 1;
        }
      } catch (error) {
        if (!error.message || error.message.indexOf('GraphQL error') === -1) {
          commit(types.SET_CART_SUCCESS_SERVER, false);
        }

        commit(types.SET_CART_SUCCESS, false);

        _this3.$logger.error(error);
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      }
    })();
  },

  update(_ref4, payload) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref4;
      var cart = null;
      var quantity = null;
      var reference = null;

      var items = _this4.state.cart.items.filter(e => e.productReference === payload.reference);

      if (items.length > 1) {
        reference = items.find(e => e.offer === payload.offer).reference;
      } else {
        reference = items[0].reference;
      }

      try {
        if (USE_MERCURE(_this4.getters['i18n/locale'].iso)) {
          var {
            updateCartItems
          } = yield updateCart(_this4, {
            cart: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN'),
            quantity: payload.quantity,
            reference
          });
          cart = updateCartItems.items;
          quantity = updateCartItems.quantity;
        } else {
          var data = yield updateCustomerCart(_this4, payload);
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: data.cartItem
          }];
          var response = yield fetchCustomerCart(_this4);
          quantity = response.cart;
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);

        _this4.$logger.error(error);
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      }
    })();
  },

  addCartCustomizable(_ref5, payload) {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      var {
        state,
        commit
      } = _ref5;
      var currentTotal = state.total;

      try {
        if (USE_MERCURE(_this5.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            logout();
          }

          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this5);
          }

          var {
            addCustomizableProductToCart
          } = yield addCartCustomizable(_this5, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'), payload);
          commit(types.SET_CART_QTY, currentTotal + 1);
          commit(types.SET_CART, addCustomizableProductToCart.items);
          commit(types.SET_CART_SUCCESS, true);
        } else {
          var data = yield addCustomerCartCustomizable(_this5, payload);

          if (data.success) {
            commit(types.SET_CART_QTY, currentTotal + 1);
            commit(types.SET_CART_SUCCESS, true);
          } else {
            commit(types.SET_CART_SUCCESS, false);
          }
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);

        _this5.$logger.error(error);
      }
    })();
  }

};